import { OrdenDeCompra } from "../com.enersol.directshopping.dal.entidad/OrdenDeCompra";

/**
 * Clase que contieen dos ordenes de compra para realizar el cambio de detalles en el servidor
 * @author gberrocal
 */
 export class OrdenesCompraCambioDTO {
  ordenDeInventario: OrdenDeCompra;
  ordenDeImportacion: OrdenDeCompra;
}